import * as types from '../actions/action-types';
import _ from 'lodash';

const stateFipsKey = 'sf';
const stateAbbrKey = 'sa';

const countyFipsKey = 'cf';
const countyNameKey = 'cn';

const defaults = {
  loading: true,
  selected: {},
  rawData: [],
  list: [],
  data: [],
  dict: {}
};

/**
 * Set Selected state and create state level data (counties)
 *
 * @param store
 * @param stateFips
 */
function setState(store, stateFips) {
  const fips = +stateFips;
  const list = getCountyList(store.rawData, fips);
  const data = _.filter(store.rawData, [stateFipsKey, fips]);

  return {
    ...store,
    list,
    data
  };
}

function getCountyList(data, stateFips) {
  return _.chain(data)
    .filter(s => s[stateFipsKey] === stateFips)
    .map(county => {
      return {
        name: county[countyNameKey],
        state: county[stateAbbrKey],
        fips: county[countyFipsKey]
      }
    })
    .uniqBy('fips')
    .orderBy('name')
    .value();
}

/**
 * Set selected county
 *
 * @param store
 * @param countyFips
 */
function setCounty(store, countyFips) {
  const county = store.dict[+countyFips];
  const selected = {
    ...county,
    name: county[countyNameKey],
    fips: county[countyFipsKey]
  };

  return {
    ...store,
    selected
  }
}

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    rawData: data.slice(),
    data: data,
    dict: _.keyBy(data, countyFipsKey)
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SELECT_STATE:
      return setState(store, action.stateFips);
    case types.SELECT_COUNTY:
      return setCounty(store, action.countyFips);
    case types.COUNTY_DATA_RECEIVED:
      return setData(store, action.data);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/counties-reducer.js